'use es6';

import { ACTION_HUB_OPT_IN, ACTION_HUB_OPT_OUT, ACTION_USER_OPT_OUT } from 'ui-addon-opt/state/OptActions';
import { Fragment } from 'react';
import AdditionalOptionsPropType from './AdditionalOptionsPropType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PositionedBetaButton from './PositionedBetaButton';
import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Optout = ({
  additionalOptions,
  dispatch,
  learnMore,
  onFeedbackSurveyClick,
  onLearnMoreClick,
  onMinimized,
  onView,
  optOutButtonText,
  showFeedbackSurvey,
  showHubOptin,
  showHubOptout,
  showIcon,
  showUserOptout
}) => {
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UIDropdown, {
      Button: PositionedBetaButton,
      buttonText: optOutButtonText,
      icon: showIcon ? undefined : 'none',
      onOpenComplete: onView,
      "data-test-id": "dropdown",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [showUserOptout && /*#__PURE__*/_jsx(UIButton, {
          onClick: () => dispatch({
            type: ACTION_USER_OPT_OUT
          }),
          "data-test-id": "userOptoutButton",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-addon-opt.optout.options.userOptout"
          })
        }), showHubOptout && /*#__PURE__*/_jsx(UIButton, {
          onClick: () => dispatch({
            type: ACTION_HUB_OPT_OUT
          }),
          "data-test-id": "hubOptoutButton",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-addon-opt.optout.options.hubOptout"
          })
        }), showHubOptin && /*#__PURE__*/_jsx(UIButton, {
          onClick: () => dispatch({
            type: ACTION_HUB_OPT_IN
          }),
          "data-test-id": "hubOptinButton",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-addon-opt.optin.options.hubOptin"
          })
        }), learnMore && /*#__PURE__*/_jsx(UIButton, {
          href: learnMore.url,
          onClick: onLearnMoreClick,
          target: "_blank",
          "data-test-id": "learnMoreButton",
          children: learnMore.text
        }), showFeedbackSurvey && /*#__PURE__*/_jsx(UIButton, {
          onClick: onFeedbackSurveyClick,
          "data-test-id": "submitFeedbackButton",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-addon-opt.optout.options.submitFeedback"
          })
        }), additionalOptions && additionalOptions.map(({
          text,
          onClick
        }, idx) => /*#__PURE__*/_jsx(UIButton, {
          onClick: onClick,
          "data-test-id": `additionalOptionsButton${idx}`,
          children: text
        }, `option-${idx}`)), /*#__PURE__*/_jsx(UIButton, {
          onClick: onMinimized,
          "data-test-id": "minimizeButton",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ui-addon-opt.common.options.minimize"
          })
        })]
      })
    })
  });
};
Optout.propTypes = {
  additionalOptions: AdditionalOptionsPropType,
  dispatch: PropTypes.func.isRequired,
  learnMore: PropTypes.shape({
    text: PropTypes.node.isRequired,
    url: PropTypes.string.isRequired
  }),
  onFeedbackSurveyClick: PropTypes.func.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
  onMinimized: PropTypes.func.isRequired,
  onView: PropTypes.func,
  optOutButtonText: PropTypes.node.isRequired,
  showFeedbackSurvey: PropTypes.bool.isRequired,
  showHubOptin: PropTypes.bool.isRequired,
  showHubOptout: PropTypes.bool.isRequired,
  showIcon: PropTypes.bool.isRequired,
  showUserOptout: PropTypes.bool.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
Optout.defaultProps = {
  onFeedbackSurveyClick: emptyFunction,
  onLearnMoreClick: emptyFunction,
  onMinimized: emptyFunction,
  onView: emptyFunction,
  optOutButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ui-addon-opt.optout.label"
  }),
  showFeedbackSurvey: false,
  showHubOptin: false,
  showHubOptout: false,
  showIcon: true,
  showUserOptout: true
};
export default Optout;